import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.sections.location.title',
    defaultMessage: 'Location',
    description: 'title of the location section on the settings page',
  },
  subtitle: {
    id: 'pages.settings.sections.location.subtitle',
    defaultMessage: 'These settings are for this device only',
    description: 'subtitle of the spooler printers section on the settings page',
  },
  editDrawer: {
    title: {
      id: 'pages.settings.sections.location.editDrawer.title',
      defaultMessage: 'Edit locations',
      description: 'title of the edit locations drawer',
    },
  },
  feedback: {
    noLocationSelected: {
      id: 'pages.settings.sections.location.feedback.noLocationSelected',
      defaultMessage: 'No location selected',
      description: 'feedback when no location is selected',
    },
    locationSettingsSaved: {
      id: 'pages.settings.sections.location.feedback.locationSettingsSaved',
      defaultMessage: 'Location settings saved',
      description: 'feedback when the printer settings were saved',
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
